import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";

const Layout = ({ children, showChrome = true }) => {
  return (
    <div className="flex min-h-screen flex-col bg-[#F8FAFC] font-sans text-slate-800">
      {showChrome && <Header />}
      <main className="flex-1">{children}</main>
      {showChrome && <Footer />}
      {showChrome && <CookieBanner />}
    </div>
  );
};

export default Layout;
